import * as React from 'react';

import EnterpriseLearningPathSkillsDataProvider from 'bundles/enterprise-learning-path-description-page/providers/EnterpriseLearningPathSkillsDataProvider';
import { useIsOrgScopedHome } from 'bundles/unified-common/hooks/useIsOrgScopedHome';
import UserDataProvider from 'bundles/unified-description-page-common/providers/user/UserDataProvider';

const EnterpriseLearningPathPageDataProvider = ({ children }: { children: React.ReactNode }) => {
  const isOrgScopedHome = useIsOrgScopedHome();

  return (
    <EnterpriseLearningPathSkillsDataProvider>
      <UserDataProvider skipFetchingOrgData={isOrgScopedHome}>{children}</UserDataProvider>
    </EnterpriseLearningPathSkillsDataProvider>
  );
};

export default EnterpriseLearningPathPageDataProvider;
